module.exports = __webpack_public_path__ + "img/red.29c8b82c.png";